import PropTypes from 'prop-types';
import SiblingButton from './siblingButton';
import Icon from '../icon';

export default function Next({ stackOrder, adobeContentType, ...otherProps }) {
  return (
    <SiblingButton
      iconPlacement="right"
      siblingType="Next"
      icon={Icon.NavigateRight}
      id={`${stackOrder}-next-btn`}
      adobeContentType={adobeContentType}
      navigationNameEventData={`next-${adobeContentType || 'article'}`}
      {...otherProps}
    />
  );
}

Next.propTypes = {
  stackOrder: PropTypes.string.isRequired,
  adobeContentType: PropTypes.string,
};

Next.defaultProps = {
  adobeContentType: undefined,
};
